import debounce from "lodash/debounce";
import useModalStore from "@utils/modal/store";

const presentDebounced = debounce(useModalStore.getState().openModal, 1000, {
  leading: true,
  trailing: false,
});

const hide = () => {
  useModalStore.setState({ hidden: true });
};

const show = () => {
  useModalStore.setState({ hidden: false });
};

export const modal = {
  close: useModalStore.getState().closeModal,
  present: presentDebounced,
  updateModalOptions: useModalStore.getState().updateModalOptions,
  hide,
  show,
  isHidden: useModalStore.getState().hidden,
  closeAllModals: useModalStore.getState().closeAllModals,
};

const useModal = () => {
  const { hidden, closeModal, closeAllModals, updateModalOptions } =
    useModalStore((state) => ({
      hidden: state.hidden,
      closeModal: state.closeModal,
      closeAllModals: state.closeAllModals,
      updateModalOptions: state.updateModalOptions,
    }));

  return {
    close: closeModal,
    present: presentDebounced,
    updateModalOptions,
    hide,
    show,
    isHidden: hidden,
    closeAllModals,
  };
};

export default useModal;
